import { projectService } from '@/services/project/project-service';
import { projectKeys } from '@/utils/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/vue-query';

type MutateBody = {
  body: Parameters<typeof projectService.setProjectStakeholders>[2];
};

interface UseProjectOrganisationExternalMutationProps {
  projectId: string;
  organisationId: string;
}

export const useProjectOrganisationExternalMutation = ({
  projectId,
  organisationId,
}: UseProjectOrganisationExternalMutationProps) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [
      'projectService',
      'setProjectStakeholders',
      projectId,
      organisationId,
    ],
    mutationFn: ({ body }: MutateBody) =>
      projectService.setProjectStakeholders(projectId, organisationId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: projectKeys.organisations({ projectId }) });
    },
  });
};
